// @ts-nocheck
import React, { useEffect, useState } from "react";
import CategoriesWithSubCat from "../components/input/CategoriesWithSubCat";
import PublicFooter from "../components/common/PublicFooter/PublicFooter";
import Loader from "../components/common/Loader/Loader";
import orderApi from "../api/orderApi";
import cityApi from "../api/cityApi";
import addressApi from "../api/addressApi";
import pincodeApi from "../api/pincodeApi";
import { useAuth } from "../context/AuthContext";
import orderPickupImage from "../assets/order.pickup.png";
import "../styles/SchedulePickup.css";

const steps = [
  "Address Details",
  "Scrap Category",
  "Preferred Date & Time",
  // "Review & Confirm",
];

const timeRange = [
  {
    id: "morning",
    label: "Morning",
    description: "8 AM - 12 PM",
    startTime: "08:00",
    endTime: "12:00",
  },
  {
    id: "afternoon",
    label: "Afternoon",
    description: "12 PM - 4 PM",
    startTime: "12:00",
    endTime: "16:00",
  },
  {
    id: "evening",
    label: "Evening",
    description: "4 PM - 8 PM",
    startTime: "16:00",
    endTime: "20:00",
  },
];

const benefits = [
  { title: "Free Doorstep Pickup", text: "No hidden charges", icon: "▣" },
  { title: "Digital Payments", text: "UPI / Cashless", icon: "▰" },
  { title: "Verified Executive", text: "Trained & background verified", icon: "♙" },
  { title: "Eco Friendly", text: "We recycle responsibly", icon: "♧" },
];

const bottomBenefits = [
  { title: "Free doorstep pickup", text: "We come to you, at no extra cost", icon: "▣" },
  { title: "Digital payment", text: "UPI / Cashless for a smooth experience", icon: "▰" },
  { title: "Verified executive", text: "Trained, polite and background verified", icon: "♙" },
  { title: "Eco responsible", text: "We segregate and recycle to protect our planet", icon: "♧" },
];

const formatAddress = (address) =>
  [address.fullAddress, address.landmark, address.city, address.pincode]
    .filter(Boolean)
    .join(", ") || "Pickup address not added";

const formatSavedAddress = (address) =>
  [address.apartment, address.city, address.state, address.zip, address.country]
    .filter(Boolean)
    .join(", ");

const getSavedAddressLabel = (address) => {
  const name = [address.receiverFirstName, address.receiverLastName]
    .filter(Boolean)
    .join(" ");
  const addressText = formatSavedAddress(address);

  return [name || "Saved Address", addressText]
    .filter(Boolean)
    .join(" - ");
};

const getTodayDateValue = () => {
  const today = new Date();
  today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
  return today.toISOString().slice(0, 10);
};

const SchedulePickup = () => {
  const { user } = useAuth();
  const currentUserId = user?.id || user?.userId || user?.userID || user?.userid;

  const [activeStep, setActiveStep] = useState(0);

  const [cities, setCities] = useState([]);
  const [citySearch, setCitySearch] = useState("");
  const [showCityList, setShowCityList] = useState(false);

  const [selectedScraps, setSelectedScraps] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedSavedAddressId, setSelectedSavedAddressId] = useState("");
  const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);
  const [pincodeStatus, setPincodeStatus] = useState("idle");
  const [pincodeMessage, setPincodeMessage] = useState("");

  const [formData, setFormData] = useState({
    fullAddress: "",
    landmark: "",
    city: "",
    pincode: "",
    mobile: "",
    email: user?.email || "",
    pickupDate: "",
    startRange: "",
    endRange: "",
    estimateWeight: "",
  });

  const getCitiesFromLocalStorage = () => {
    try {
      const storedCities = localStorage.getItem("cities");
      return storedCities ? JSON.parse(storedCities) : null;
    } catch (error) {
      console.error("Failed to read cities from localStorage:", error);
      return null;
    }
  };

  useEffect(() => {
    const loadCities = async () => {
      try {
        const localCities = getCitiesFromLocalStorage();

        if (localCities && localCities.length > 0) {
          setCities(localCities);
          return;
        }

        const apiCities = await cityApi.getCities();

        setCities(apiCities || []);
        localStorage.setItem("cities", JSON.stringify(apiCities || []));
      } catch (error) {
        console.error("Failed to load cities:", error);
        setCities([]);
      }
    };

    loadCities();
  }, []);

  useEffect(() => {
    const loadSavedAddresses = async () => {
      if (!currentUserId) {
        setSavedAddresses([]);
        setSelectedSavedAddressId("");
        return;
      }

      try {
        setIsLoadingAddresses(true);
        const addresses = await addressApi.getMyAddresses(currentUserId);
        setSavedAddresses(addresses);
      } catch (error) {
        console.error("Failed to load saved addresses:", error);
        setSavedAddresses([]);
      } finally {
        setIsLoadingAddresses(false);
      }
    };

    loadSavedAddresses();
  }, [currentUserId]);

  useEffect(() => {
    const pinCode = formData.pincode.trim();

    if (!pinCode) {
      setPincodeStatus("idle");
      setPincodeMessage("");
      return;
    }

    if (pinCode.length < 6) {
      setPincodeStatus("error");
      setPincodeMessage("Enter a 6 digit pincode.");
      return;
    }

    if (!/^[0-9]{6}$/.test(pinCode)) {
      setPincodeStatus("error");
      setPincodeMessage("Please enter a valid 6 digit pincode.");
      return;
    }

    let isCurrent = true;

    setPincodeStatus("checking");
    setPincodeMessage("Checking service availability...");

    const timeoutId = window.setTimeout(async () => {
      try {
        const isAvailable = await pincodeApi.isAvailable(pinCode);

        if (!isCurrent) {
          return;
        }

        if (isAvailable) {
          setPincodeStatus("available");
          setPincodeMessage("");
        } else {
          setPincodeStatus("unavailable");
          setPincodeMessage("Pickup is not available for this pincode yet.");
        }
      } catch (error) {
        if (!isCurrent) {
          return;
        }

        setPincodeStatus("error");
        setPincodeMessage(error?.message || "Failed to validate pincode.");
      }
    }, 350);

    return () => {
      isCurrent = false;
      window.clearTimeout(timeoutId);
    };
  }, [formData.pincode]);

  const cityOptions = cities.map((city) => city.name || city.cityName || city);

  const filteredCities = cityOptions.filter((city) =>
    city.toLowerCase().includes(citySearch.toLowerCase())
  );

  const handleCitySelect = (city) => {
    setSelectedSavedAddressId("");
    setFormData((current) => ({
      ...current,
      city,
    }));

    setCitySearch("");
    setShowCityList(false);
  };

  const formatScrapPrice = (item) => {
    const minPrice = Number(item.minPrice);
    const maxPrice = Number(item.maxPrice);
    const price = Number(item.price);
    const unit = item.categoryForReSell ? "" : "/kg";

    if (minPrice > 0 && maxPrice > 0 && minPrice !== maxPrice) {
      return `Rs ${minPrice} - ${maxPrice}${unit}`;
    }

    const displayPrice = minPrice > 0 ? minPrice : price;
    return displayPrice > 0 ? `Rs ${displayPrice}${unit}` : "-";
  };

  const selectedItems =
  selectedScraps.length > 0
    ? selectedScraps.map((item) => ({
        icon: "♻",
        name: item.subCategoryName || "Selected scrap item",
        quantity: formData.estimateWeight
          ? `${formData.estimateWeight} kg`
          : "Qty/Est.",
        price: formatScrapPrice(item),
      }))
    : [];
  const selectedTimeSlot = timeRange.find(
    (time) => time.startTime === formData.startRange && time.endTime === formData.endRange
  );

  const handleChange = (event) => {
    const { name, value } = event.target;
    const nextValue = name === "pincode" ? value.replace(/\D/g, "").slice(0, 6) : value;

    setSelectedSavedAddressId("");
    setFormData((current) => ({
      ...current,
      [name]: nextValue,
    }));
  };

  const handleSavedAddressSelect = (address) => {
    setSelectedSavedAddressId(String(address.id));
    setFormData((current) => ({
      ...current,
      fullAddress: address.apartment || "",
      landmark: "",
      city: address.city || "",
      pincode: address.zip || "",
      mobile: address.receiverPhone || "",
      email: address.receiverEmail || user?.email || current.email,
    }));
    setShowCityList(false);
  };

  const handleSavedAddressMenuChange = (event) => {
    const addressId = event.target.value;

    if (!addressId) {
      setSelectedSavedAddressId("");
      return;
    }

    const selectedAddress = savedAddresses.find((address) => String(address.id) === addressId);

    if (selectedAddress) {
      handleSavedAddressSelect(selectedAddress);
    }
  };

  const handleCategorySelect = (items) => {
    setSelectedScraps(items);
  };

  const handleTimeSlotSelect = (slot) => {
    setFormData((current) => ({
      ...current,
      startRange: slot.startTime,
      endRange: slot.endTime,
    }));
  };

  const buildSubCategoryIds = () =>
    selectedScraps
      .map((item) => Number(item.subCategoryID))
      .filter((subCategoryId) => Number.isFinite(subCategoryId));

  const goNext = () => {
    setActiveStep((current) => Math.min(current + 1, steps.length - 1));
  };

  const validate = async () => {
    if (!formData.fullAddress.trim() || !formData.city.trim() || !formData.pincode.trim()) {
      window.alert("Please complete address details");
      setActiveStep(0);
      return false;
    }

    if (!/^[0-9]{6}$/.test(formData.pincode.trim())) {
      window.alert("Please enter a valid 6 digit pincode");
      setActiveStep(0);
      return false;
    }

    if (!cityOptions.includes(formData.city)) {
      window.alert("Please select city from the list");
      setActiveStep(0);
      return false;
    }

    if (!formData.mobile.trim()) {
      window.alert("Please enter mobile number");
      setActiveStep(0);
      return false;
    }

    if (pincodeStatus === "checking") {
      window.alert("Please wait while we check pincode availability");
      setActiveStep(0);
      return false;
    }

    let isPincodeAvailable = pincodeStatus === "available";

    if (pincodeStatus !== "available" && pincodeStatus !== "unavailable") {
      try {
        isPincodeAvailable = await pincodeApi.isAvailable(formData.pincode);
      } catch (error) {
        window.alert(error?.message || "Failed to validate pincode");
        setActiveStep(0);
        return false;
      }
    }

    if (!isPincodeAvailable) {
      window.alert("Pickup is not available for this pincode yet");
      setActiveStep(0);
      return false;
    }

    if (selectedScraps.length === 0) {
      window.alert("Please select at least one scrap item");
      setActiveStep(1);
      return false;
    }

    if (!formData.pickupDate || !formData.startRange || !formData.endRange) {
      window.alert("Please select pickup date and time");
      setActiveStep(2);
      return false;
    }

    if (!formData.estimateWeight || Number(formData.estimateWeight) <= 0) {
      window.alert("Please enter estimated weight");
      setActiveStep(2);
      return false;
    }

    if (formData.endRange <= formData.startRange) {
      window.alert("End time must be after start time");
      setActiveStep(2);
      return false;
    }

    return true;
  };

  const handleConfirmPickup = async () => {
    if (isSubmitting) {
      return;
    }

    if (!(await validate())) {
      return;
    }

    const [firstName = "Guest", ...lastNameParts] = (
      user?.firstName ||
      user?.username ||
      "Guest Customer"
    ).split(" ");

    const lastName = user?.lastName || lastNameParts.join(" ") || "Customer";

    const payload = {
      status: "Created",
      createdByUserID: currentUserId || null,
      pickupDate: formData.pickupDate,
      startRange: formData.startRange,
      endRange: formData.endRange,
      estimateWeight: Number(formData.estimateWeight),

      subCategoriesIDs: buildSubCategoryIds(),

      address: {
        id: selectedSavedAddressId ? Number(selectedSavedAddressId) : null,
        apartment: formData.fullAddress,
        city: formData.city,
        state: "Uttar Pradesh",
        zip: formData.pincode,
        country: "India",
        receiverFirstName: firstName,
        receiverLastName: lastName,
        receiverPhone: formData.mobile,
        receiverEmail: formData.email || user?.email || "customer@kabaadkart.com",
        countryCode: "+91",
      },
    };

    try {
      setIsSubmitting(true);
      await orderApi.createOrder(payload);
      window.alert("Pickup scheduled successfully");
    } catch (error) {
      window.alert(error?.message || "Failed to schedule pickup");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="schedule-page">
      <section className="schedule-hero">
        <div className="schedule-hero-image" style={{ "--schedule-hero-image": `url(${orderPickupImage})` }} />

        <div className="schedule-hero-copy">
          <div>
            <h1>
              Schedule <span>Pickup</span>
            </h1>
            <p>
              Book a free pickup at your convenience. Our verified executive will arrive on time
              and handle everything.
            </p>
          </div>

          <div className="schedule-benefits">
            {benefits.map((item) => (
              <article key={item.title}>
                <span>{item.icon}</span>
                <strong>{item.title}</strong>
                <small>{item.text}</small>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="schedule-shell">
        <div className="schedule-main">
          <div className="schedule-steps">
            {steps.map((step, index) => (
              <button
                className={`schedule-step ${activeStep === index ? "active" : ""}`}
                key={step}
                type="button"
                onClick={() => setActiveStep(index)}
              >
                <span>{index + 1}</span>
                {step}
              </button>
            ))}
          </div>

          <div className="schedule-card">
            {activeStep === 0 ? (
              <>
                <section>
                  <h2>Address Details</h2>

                  {user?.id ? (
                    <div className="saved-address-panel">
                      <div className="saved-address-header">
                        <strong>Saved Addresses</strong>
                        <span>
                          {isLoadingAddresses ? <Loader size="sm" inline /> : `${savedAddresses.length} saved`}
                        </span>
                      </div>

                      {savedAddresses.length > 0 ? (
                        <label className="saved-address-menu">
                          Choose saved address
                          <select value={selectedSavedAddressId} onChange={handleSavedAddressMenuChange}>
                            <option value="">Enter a new address</option>
                            {savedAddresses.map((address) => (
                              <option key={address.id} value={address.id}>
                                {getSavedAddressLabel(address)}
                              </option>
                            ))}
                          </select>
                        </label>
                      ) : (
                        <p className="saved-address-empty">
                          {isLoadingAddresses ? (
                            <Loader size="sm" inline label="Loading saved addresses..." />
                          ) : (
                            "No saved addresses yet. Add one below."
                          )}
                        </p>
                      )}
                    </div>
                  ) : null}

                  <div className="schedule-form-grid">
                    <label className="schedule-field full">
                      Full Address
                      <input
                        name="fullAddress"
                        value={formData.fullAddress}
                        onChange={handleChange}
                        placeholder="221B, 2nd Main Road"
                      />
                    </label>

                    <label className="schedule-field full">
                      Landmark <small>(Optional)</small>
                      <input
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleChange}
                        placeholder="Near metro station"
                      />
                    </label>

                    <label className="schedule-field city-dropdown-wrapper">
                      City

                      <div className="city-dropdown">
                        <button
                          type="button"
                          className="city-selected"
                          onClick={() => setShowCityList((current) => !current)}
                        >
                          {formData.city || "Select City"}
                        </button>

                        {showCityList ? (
                          <div className="city-dropdown-menu">
                            <input
                              type="text"
                              value={citySearch}
                              onChange={(event) => setCitySearch(event.target.value)}
                              placeholder="Search city"
                              className="city-search-input"
                            />

                            <div className="city-list">
                              {filteredCities.length > 0 ? (
                                filteredCities.map((city) => (
                                  <button
                                    key={city}
                                    type="button"
                                    className="city-option"
                                    onClick={() => handleCitySelect(city)}
                                  >
                                    {city}
                                  </button>
                                ))
                              ) : (
                                <p className="city-no-result">No city found</p>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </label>

                    <label className="schedule-field">
                      Pincode
                      <input
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        inputMode="numeric"
                        maxLength="6"
                        placeholder="201310"
                        className={
                          pincodeStatus === "unavailable" || pincodeStatus === "error"
                            ? "input-error"
                            : ""
                        }
                        aria-invalid={pincodeStatus === "unavailable" || pincodeStatus === "error"}
                      />
                      {pincodeMessage ? (
                        <small className={`pincode-error ${pincodeStatus}`}>
                          {pincodeMessage}
                        </small>
                      ) : null}
                    </label>

                    <label className="schedule-field">
                      Mobile Number
                      <input
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="+91 98765 43210"
                      />
                    </label>

                    <label className="schedule-field">
                      Email
                      <input
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="you@example.com"
                      />
                    </label>
                  </div>
                </section>

                {/* <aside className="schedule-payment">
                  <h3>Payment Preference</h3>

                  {["UPI / Cashless", "Cash on Pickup"].map((mode) => (
                    <button
                      className={`payment-option ${paymentMode === mode ? "active" : ""}`}
                      key={mode}
                      type="button"
                      onClick={() => setPaymentMode(mode)}
                    >
                      <span />

                      <span>
                        <strong>{mode}</strong>
                        <small>
                          {mode === "UPI / Cashless"
                            ? "Pay digitally after pickup"
                            : "Pay in cash to our executive"}
                        </small>
                      </span>

                      <b>{mode === "UPI / Cashless" ? "UPI" : "₹"}</b>
                    </button>
                  ))}

                  <div className="safe-box">
                    <span>♢</span>

                    <div>
                      <strong>Your data is safe with us</strong>
                      <small>We never share your information with anyone.</small>
                    </div>
                  </div>
                </aside> */}

                <div className="schedule-actions">
                  <button className="schedule-next" type="button" onClick={goNext}>
                    Save & Continue →
                  </button>
                </div>
              </>
            ) : null}

            {activeStep === 1 ? (
              <section className="schedule-category-step">
                <h2>Scrap Category</h2>

                <CategoriesWithSubCat
                  selectedItems={selectedScraps}
                  onSelect={handleCategorySelect}
                />

                <div className="schedule-actions">
                  <button className="schedule-next" type="button" onClick={goNext}>
                    Continue →
                  </button>
                </div>
              </section>
            ) : null}

            {activeStep === 2 ? (
              <section>
                <h2>Preferred Date & Time</h2>

                <div className="schedule-form-grid">
                  <label className="schedule-field">
                    Pickup Date
                    <input
                      type="date"
                      name="pickupDate"
                      value={formData.pickupDate}
                      onChange={handleChange}
                      min={getTodayDateValue()}
                    />
                  </label>

                  <div className="schedule-field pickup-slot-field">
                    <span>Pickup Time</span>

                    <div className="pickup-slot-grid" role="radiogroup" aria-label="Pickup time slot">
                      {timeRange.map((time) => {
                        const isSelected = selectedTimeSlot?.id === time.id;

                        return (
                          <button
                            key={time.id}
                            type="button"
                            className={`pickup-slot-option ${isSelected ? "active" : ""}`}
                            onClick={() => handleTimeSlotSelect(time)}
                            role="radio"
                            aria-checked={isSelected}
                          >
                            <span>{time.label}</span>
                            <strong>{time.description}</strong>
                          </button>
                        );
                      })}
                    </div>

                    <small>
                      {selectedTimeSlot
                        ? `Selected: ${selectedTimeSlot.description}`
                        : "Choose a convenient pickup window."}
                    </small>
                  </div>

                  <label className="schedule-field">
                    Estimated Weight
                    <input
                      type="number"
                      min="1"
                      step="0.1"
                      name="estimateWeight"
                      value={formData.estimateWeight}
                      onChange={handleChange}
                      placeholder="25 kg"
                    />
                  </label>
                </div>

                {/* <div className="schedule-actions">
                  <button className="schedule-next" type="button" onClick={goNext}>
                    Review Order →
                  </button>
                </div> */}
              </section>
            ) : null}

            {/* {activeStep === 3 ? (
              <section>
                <h2>Review & Confirm</h2>

                <p>
                  Review your address, selected scrap item, estimated weight, and pickup slot
                  before confirming.
                </p>

                <button className="schedule-confirm" type="button" onClick={handleConfirmPickup} disabled={isSubmitting}>
                  {isSubmitting ? "Confirming..." : "Confirm Pickup →"}
                </button>
              </section>
            ) : null} */}
          </div>
        </div>

        <aside className="schedule-summary">
          <h2>Your Order Summary</h2>

          <div className="summary-address">
            <span>●</span>
            <p>{formatAddress(formData)}</p>

            <button type="button" onClick={() => setActiveStep(0)}>
              Edit
            </button>
          </div>

          <div className="summary-list">
            {selectedItems.map((item, index) => (
              <div className="summary-row" key={`${item.name}-${index}`}>
                <span>{item.icon}</span>

                <span>
                  <strong>{item.name}</strong>
                  <small>{item.quantity}</small>
                </span>

                <b>{item.price}</b>
              </div>
            ))}
          </div>

          <div className="summary-totals">
            <div>
              <span>Total Selected Items</span>
              <b>{selectedScraps.length}</b>
            </div>

            <div>
              <span>Total Estimated Weight</span>
              <b>{formData.estimateWeight || "-"} kg</b>
            </div>

            <div>
              <span>Pickup Fee</span>
              <strong>FREE</strong>
            </div>
          </div>

          <p className="summary-note">
            Final price is confirmed after actual weight and quality are checked at pickup.
          </p>

          <button className="schedule-confirm" type="button" onClick={handleConfirmPickup} disabled={isSubmitting}>
            {isSubmitting ? "Confirming..." : "Confirm Pickup →"}
          </button>

          <p className="summary-secure">✓ 100% Secure · No hidden charges</p>
        </aside>
      </section>

      <section className="schedule-bottom-strip">
        {bottomBenefits.map((item) => (
          <article key={item.title}>
            <span>{item.icon}</span>

            <div>
              <strong>{item.title}</strong>
              <small>{item.text}</small>
            </div>
          </article>
        ))}
      </section>

      <PublicFooter className="schedule-footer" copybarClassName="schedule-copybar" />
    </main>
  );
};

export default SchedulePickup;
